export class AllBalanceUser {
    balanceReal: number;
    balanceDolar: number;
    balanceSm: number;
    balanceBs: number;
    inOrderReal: number;
    inOrderDolar: number;
    inOrderSm: number;
    inOrderBs: number;
}
